import React from 'react';
import Layout from '../../components/Shared/Layout';
import Bbqguru from '../../components/Portfolio/bbqguru';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class BbqGuruPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/bbqguru',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <Bbqguru />
      </Layout>
    );
  }
}

export default BbqGuruPage;
